var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms",
    transform: "translate(-0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30846",
    "data-name": "Path 30846",
    d: "M17.366,21.75H7.134c-3.735,0-5.884-2.157-5.884-5.905V8.655C1.25,4.907,3.4,2.75,7.134,2.75H17.366c3.735,0,5.884,2.157,5.884,5.905v7.189C23.25,19.593,21.1,21.75,17.366,21.75ZM7.134,4.291c-2.927,0-4.349,1.428-4.349,4.365v7.189c0,2.937,1.422,4.365,4.349,4.365H17.366c2.927,0,4.349-1.428,4.349-4.365V8.655c0-2.937-1.422-4.365-4.349-4.365Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30847",
    "data-name": "Path 30847",
    d: "M12.25,12.87a3.99,3.99,0,0,1-2.442-.79L6.542,9.58a.727.727,0,0,1-.125-1.05.8.8,0,0,1,1.1-.12l3.266,2.5a2.578,2.578,0,0,0,2.932,0l3.266-2.5a.793.793,0,0,1,1.1.12.718.718,0,0,1-.125,1.05l-3.266,2.5A3.938,3.938,0,0,1,12.25,12.87Z",
    transform: "translate(0 0.198)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8469",
    "data-name": "Rectangle 8469",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMail);
export default __webpack_public_path__ + "static/media/profile-mail.4ccaebc73406709585e1fcd959f239f1.svg";
export { ForwardRef as ReactComponent };